import { OverflowMenu } from './types';

export const createOverflowMenu = (): OverflowMenu => {
  const overflowMenuItem = document.createElement('li');
  overflowMenuItem.className = 'header-menu__item overflow-menu';
  overflowMenuItem.innerHTML = `<a href="#" class="overflow-menu__toggle header-link header-link--gradient header-link--inverted"><span class="typography typography--menu-item header-link__text">Další</span><span class="header-link__icon header-link__icon--right"><svg class="overflow-menu__arrow" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M11.6147 5.5293L8.55469 8.58263L5.49469 5.5293L4.55469 6.4693L8.55469 10.4693L12.5547 6.4693L11.6147 5.5293Z" fill="#ffffff"/></svg></a>`;

  const overflowMenuList = document.createElement('ul');
  overflowMenuList.className = 'overflow-menu__list';
  overflowMenuItem.appendChild(overflowMenuList);

  const toggle = overflowMenuItem.querySelector('.overflow-menu__toggle') as HTMLElement;
  toggle.addEventListener('click', () => {
    overflowMenuItem.classList.toggle('active');
  });

  return { overflowMenuItem, overflowMenuList };
};
